module.exports = __webpack_public_path__ + "img/FR16438.64817db9.png";